import { useQuery } from '@tanstack/react-query'
import { request } from 'Features/Auth/axios-client'
import { Scenario } from '../ProjectDetails/ProjectDetails.types'

const fetchScenarios = async (projectId: string) => {
  const data = await request({
    url: `/projects/${projectId}/details`,
    method: 'GET',
  })
  return data
}

export const useScenarios = (projectId: string) => {
  return useQuery({
    queryKey: ['scenarios', projectId],
    queryFn: () => fetchScenarios(projectId),
    enabled: !!projectId,
    gcTime: 0, // renamed from cacheTime in v5
    select: ({ data }) => {
      return data?.data?.scenariosList.filter(
        (scenario: Scenario) => scenario.createdOn !== null
      )
    },
  })
}
